exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.nav-link[data-v-b1c2d420]{border-left:0;border-top:0;border-bottom:0}", ""]);

// exports
